import React from 'react';
import { node, bool, func } from 'prop-types';
import { noop } from 'lodash';
import classnames from 'classnames';
import { Tooltip } from '@fiverr-private/fit';

import './style.scss';

const IconWrapper = ({ isOpen, onClick = noop, children, tooltip }) => (
    <div
        className={classnames('seller-main-icon', 'flex-center', { 'seller-dropdown-open': isOpen })}
        onClick={onClick}
    >
        {tooltip ? (
            <Tooltip content={tooltip} containerClassName="seller-tooltip-top-header">
                {children}
            </Tooltip>
        ) : (
            children
        )}
    </div>
);

IconWrapper.propTypes = {
    isOpen: bool,
    children: node.isRequired,
    onClick: func,
    tooltip: node,
};

export default IconWrapper;
